'use client'

// React Imports
import { useEffect } from 'react'

// Next Imports
import { redirect, usePathname } from 'next/navigation'

// Third-party Imports
import { useSession } from 'next-auth/react'

// Config Imports
import themeConfig from '@configs/themeConfig'

const AuthRedirect = () => {
  const pathname = usePathname()
  const { status } = useSession()
  const login = '/login'
  const homePage = themeConfig.homePageUrl

  useEffect(() => {
    if (status === 'unauthenticated' && pathname !== login) {
      redirect(`/login?redirectTo=${pathname}`)
    }

    if (status === 'authenticated' && pathname === login) {
      redirect(homePage)
    }
  }, [status, pathname, homePage])

  return null
}

export default AuthRedirect
